<template v-if="isCitizenMaintenance">
  <div class="d-flex flex-column flex-root">
    <div
      class="st-auth d-flex flex-column flex-lg-row flex-column-fluid bg-white"
      id="st_maintenance"
    >
      <!--begin::Aside-->
      <div
        class="st-auth-aside d-flex flex-column flex-row-auto"
        :style="{ backgroundImage: `url(${backgroundImage})` }"
      >
        <div class="d-flex flex-column-auto flex-column st-auth-aside-logo">
          <a href="#" class="text-center mt-10 mt-lg-0 mb-10">
            <img :src="logoImage" class="max-h-70px" alt=""/>
          </a>
        </div>
      </div>
      <!--end::Aside-->
      
      <!--begin::Content-->
      <div
        class="st-auth-content flex-row-fluid d-flex flex-column justify-content-center position-relative overflow-hidden p-7 mx-auto"
      >
        <div class="d-flex flex-column-fluid flex-center">
          <div class="maintenance-content text-center">
            <i class="fas fa-tools fa-5x text-warning mb-5"></i>
            <h1 class="mb-3">{{ $t('GENERAL.CITIZEN_MAINTENANCE_TITLE') }}</h1>
            <p class="text-muted font-size-lg">{{ maintenanceText || $t('GENERAL.MAINTENANCE_MESSAGE') }}</p>
          </div>
        </div>
      </div>
      <!--end::Content-->
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  name: 'MaintenancePage',
  data() {
    return {
      backgroundImage: `${process.env.BASE_URL}media/st-login-bg.jpg`,
      logoImage: `${process.env.BASE_URL}media/st-logo.svg`
    };
  },
  computed: {
    ...mapGetters({
      appConfig: 'shared/publicAppConfig',
    }),
    isCitizenMaintenance() {
        return this.appConfig.CITIZEN_MAINTENANCE;
    },
    maintenanceText() {
      return this.appConfig.CITIZEN_MAINTENANCE_TEXT || this.appConfig.MAINTENANCE_TEXT;
    }
  }
};
</script>

<style lang="scss">
@import '@/assets/sass/pages/auth/auth-layout.scss';

  .maintenance-content {
    max-width: 600px;
    padding: 2rem;
  }
</style>